import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './constants';

const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const MOBILE_DEVICE_CONNECT = createApiNamespacedConstants('MOBILE_DEVICE_CONNECT');
export const MOBILE_DEVICE_DISCONNECT = `${NAMESPACE}/MOBILE_DEVICE_DISCONNECT`;
export const MOBILE_DEVICE_STATE_UPDATE = `${NAMESPACE}/MOBILE_DEVICE_STATE_UPDATE`;
